import type { CreateContractRequest } from "../../../shared/models/contract.types";

/**
 * Mapeia as escolhas do usuário para o formato esperado pelo backend
 */
export const getCheckboxData = (userData: any) => {
  const checkboxData: any = {};

  // Cartão de crédito
  if (userData?.cardAcquired === "yes") {
    checkboxData.simCartaoCredito = true;
    
    // Tipo de cartão
    if (userData?.cardType === "nacional") {
      checkboxData.cartaoCreditoNasc = true;
    } else if (userData?.cardType === "internacional") {
      checkboxData.cartaoCreditoInt = true;
    }
    
    // Seguro de proteção
    if (userData?.insuranceProtection === "sim") {
      checkboxData.coberturaSim = true;
    } else if (userData?.insuranceProtection === "nao") {
      checkboxData.coberturaNao = true;
    }
    
    // Data de vencimento da fatura
    const expirationDate = userData?.cardExpirationDate;
    if (expirationDate === 1) checkboxData.dia1 = true;
    else if (expirationDate === 5) checkboxData.dia5 = true;
    else if (expirationDate === 10) checkboxData.dia10 = true;
    else if (expirationDate === 15) checkboxData.dia15 = true;
    else if (expirationDate === 20) checkboxData.dia20 = true;
    else if (expirationDate === 25) checkboxData.dia25 = true;
    
  } else if (userData?.cardAcquired === "no") {
    checkboxData.naoCartaoCredito = true;
  }

  // Cheque especial
  if (userData?.specialCheck === "sim") {
    checkboxData.simChequeEspecial = true;
  } else if (userData?.specialCheck === "nao") {
    checkboxData.naoChequeEspecial = true;
  }

  // Cartão magnético
  if (userData?.magneticCard === "sim") {
    checkboxData.simCartaoMagnetico = true;
    
    // Tipo de cartão magnético
    if (userData?.magneticCardType === "definitivo") {
      checkboxData.cartaoMagneticoDef = true;
    } else if (userData?.magneticCardType === "nb") {
      checkboxData.cartaoMagneticoNb = true;
    }
  } else if (userData?.magneticCard === "nao") {
    checkboxData.naoCartaoMagnetico = true;
  }

  // Conta corrente
  if (userData?.currentAccount === "sim") {
    checkboxData.simContaCorrente = true;
    
    // Conta corrente individual
    if (userData?.currentAccountIndividual === "sim") {
      checkboxData.contaCorrenteIndiv = true;
    }
  } else if (userData?.currentAccount === "nao") {
    checkboxData.naoContaCorrente = true;
  }

  return checkboxData;
};

/**
 * Cria o payload do contrato com todos os dados necessários
 */
export const createContractPayload = (
  mailingData: any,
  userData: any,
  publicId: string,
  assinatura: string = "",
  order: number = 1
): CreateContractRequest => {
  return {
    nomeCompleto: mailingData?.nome || "",
    nomeSocial: userData?.nomeSocial || "",
    cpf: mailingData?.cpf || "",
    numeroBeneficio: mailingData?.numeroBeneficio || "",
    numConta: mailingData?.numConta || userData?.numConta || "",
    codLoja: mailingData?.storeDescription || "",
    checkbox: order === 1 ? getCheckboxData(userData) : getSecondDocumentCheckboxData(userData),
    order: order,
    unidadeId: userData?.unidadeId || 80,
    publicId: publicId,
    inquiryId: mailingData?.inquiryId || 0,
    data: new Date().toLocaleDateString("pt-BR"),
    assinatura: assinatura
  };
};

/**
 * Mapeia apenas os dados específicos para o segundo documento
 */
export const getSecondDocumentCheckboxData = (userData: any) => {
  const checkboxData: any = {};

  // Para o segundo documento, enviar apenas os dados específicos que requerem segundo documento
  
  // Cartão de crédito (se selecionado)
  if (userData?.cardAcquired === "yes") {
    checkboxData.simCartaoCredito = true;
    
    if (userData?.cardType === "nacional") {
      checkboxData.cartaoCreditoNasc = true;
    } else if (userData?.cardType === "internacional") {
      checkboxData.cartaoCreditoInt = true;
    }
    
    if (userData?.insuranceProtection === "sim") {
      checkboxData.coberturaSim = true;
    } else if (userData?.insuranceProtection === "nao") {
      checkboxData.coberturaNao = true;
    }
    
    const expirationDate = userData?.cardExpirationDate;
    if (expirationDate === 1) checkboxData.dia1 = true;
    else if (expirationDate === 5) checkboxData.dia5 = true;
    else if (expirationDate === 10) checkboxData.dia10 = true;
    else if (expirationDate === 15) checkboxData.dia15 = true;
    else if (expirationDate === 20) checkboxData.dia20 = true;
    else if (expirationDate === 25) checkboxData.dia25 = true;
  }

  // Cheque especial (se selecionado)
  if (userData?.specialCheck === "sim") {
    checkboxData.simChequeEspecial = true;
  }

  // Cartão magnético (se selecionado)
  if (userData?.magneticCard === "sim") {
    checkboxData.simCartaoMagnetico = true;
    
    if (userData?.magneticCardType === "definitivo") {
      checkboxData.cartaoMagneticoDef = true;
    } else if (userData?.magneticCardType === "nb") {
      checkboxData.cartaoMagneticoNb = true;
    }
  }

  // Conta corrente (se selecionado)
  if (userData?.currentAccount === "sim") {
    checkboxData.simContaCorrente = true;
    
    if (userData?.currentAccountIndividual === "sim") {
      checkboxData.contaCorrenteIndiv = true;
    }
  }

  console.log('ContractUtils - Segundo documento checkbox data:', checkboxData);
  
  return checkboxData;
};

/**
 * Verifica se o usuário precisa de um segundo documento (cartão de crédito, cheque especial, cartão magnético ou conta corrente)
 */
export const needsSecondDocument = (userData: any): boolean => {
  // Verificar tanto strings quanto booleans para compatibilidade
  const cardAcquired = userData?.cardAcquired === "yes" || userData?.cardAcquired === true;
  const specialCheck = userData?.specialCheck === "sim" || userData?.specialCheck === true;
  const magneticCard = userData?.magneticCard === "sim" || userData?.magneticCard === true;
  const currentAccount = userData?.currentAccount === "sim" || userData?.currentAccount === true;
  
  const needsSecond = cardAcquired || specialCheck || magneticCard || currentAccount;
  
  console.log('ContractUtils - needsSecondDocument:', {
    cardAcquired: userData?.cardAcquired,
    specialCheck: userData?.specialCheck,
    magneticCard: userData?.magneticCard,
    currentAccount: userData?.currentAccount,
    cardAcquiredBool: cardAcquired,
    specialCheckBool: specialCheck,
    magneticCardBool: magneticCard,
    currentAccountBool: currentAccount,
    needsSecond
  });
  
  return needsSecond;
};

/**
 * Salva os dados necessários no localStorage para uso posterior
 */
export const saveContractDataToStorage = (mailingData: any, userData: any) => {
  localStorage.setItem('mailingData', JSON.stringify(mailingData));
  localStorage.setItem('userData', JSON.stringify(userData));
};

/**
 * Recupera os dados do contrato do localStorage
 */
export const getContractDataFromStorage = () => {
  const mailingDataStr = localStorage.getItem('mailingData');
  const userDataStr = localStorage.getItem('userData');
  
  if (!mailingDataStr || !userDataStr) {
    throw new Error('Dados do usuário não encontrados no localStorage');
  }
  
  const parsedData = {
    mailingData: JSON.parse(mailingDataStr),
    userData: JSON.parse(userDataStr)
  };
  
  return parsedData;
};

/**
 * Limpa os dados do contrato do localStorage
 */
export const clearContractDataFromStorage = () => {
  localStorage.removeItem('contractDocument');
  localStorage.removeItem('mailingData');
  localStorage.removeItem('userData');
};

/**
 * Salva o contrato assinado no localStorage
 */
export const saveSignedContractToStorage = (contractData: any) => {
  let contractBase64;
  
  if (contractData instanceof ArrayBuffer) {
    const bytes = new Uint8Array(contractData);
    let binary = '';
    for (let i = 0; i < bytes.length; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    contractBase64 = btoa(binary);
  } else if (typeof contractData === 'string') {
    contractBase64 = contractData;
  } else {
    contractBase64 = contractData;
  }
  
  localStorage.setItem('signedContractDocument', contractBase64);
  console.log('ContractUtils - Contrato assinado salvo no localStorage');
};

/**
 * Verifica se existe um contrato assinado no localStorage
 */
export const hasSignedContract = (): boolean => {
  return localStorage.getItem('signedContractDocument') !== null;
};

/**
 * Limpa todos os dados relacionados ao contrato (assinado e não assinado)
 */
export const clearAllContractData = () => {
  localStorage.removeItem('contractDocument');
  localStorage.removeItem('signedContractDocument');
  localStorage.removeItem('mailingData');
  localStorage.removeItem('userData');
};
